import type {
  RouteLocationAsRelativeGeneric,
  RouteLocationRaw,
} from 'vue-router'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

/**
 * This composable adds the current locale param to a route.
 * It is useful to resolve a route that needs a locale param, when your current route does not have it in its path.
 * Otherwise, the route resolution will throw an error.
 */
export const useRedirectLocale = () => {
  const locale = useI18nLocale()

  const isNamedRoute = (
    to: Exclude<RouteLocationRaw, string>,
  ): to is RouteLocationAsRelativeGeneric => {
    return typeof to === 'object' && to !== null && 'name' in to
  }

  const getRouteLocationWithLocale = (
    route: Exclude<RouteLocationRaw, string>,
  ) => {
    if (isNamedRoute(route)) {
      return {
        ...route,
        params: {
          ...(route.params ?? {}),
          // if no locale params is expected on that route, it will be ignored
          locale,
        },
      }
    }

    return route
  }

  return {
    getRouteLocationWithLocale,
  }
}
